<template>
    <div class="social-box-container">
        <a class="social-box" v-if="settings.socialLinks.whatsapp" :href="settings.socialLinks.whatsapp" target="_blank" @click="joinWhatsapp(settings.socialLinks.whatsapp)">
            <span class="social-img-container">
                <img v-lazyload :src="'/assets/img/logo-whatsapp.png'">
            </span>
            <span>JOIN US ON WHATSAPP</span>
        </a>
        <a class="social-box" v-if="settings.socialLinks.twitter" :href="settings.socialLinks.twitter" target="_blank" @click="trackOutboundLink(settings.socialLinks.twitter)">
            <span class="social-img-container"><img v-lazyload :src="'/assets/img/logo-twitter.jpg'"></span>
            <span>FIND US ON TWITTER</span>
        </a>
        <a class="social-box" v-if="settings.socialLinks.facebook" :href="settings.socialLinks.facebook" target="_blank" @click="trackOutboundLink(settings.socialLinks.facebook)">
            <span class="social-img-container"><img v-lazyload :src="'/assets/img/logo-facebook.jpg'"></span>
            <span>LIKE US ON FACEBOOK</span>
        </a>
        <a class="social-box" v-if="settings.socialLinks.instagram" :href="settings.socialLinks.instagram" target="_blank" @click="trackOutboundLink(settings.socialLinks.instagram)">
            <span class="social-img-container"><img v-lazyload :src="'/assets/img/logo-instagram.jpg'"></span>
            <span>FOLLOW US ON INSTAGRAM</span>
        </a>
        <a class="social-box" v-if="settings.socialLinks.pinterest" :href="settings.socialLinks.pinterest" target="_blank" @click="trackOutboundLink(settings.socialLinks.pinterest)">
            <span class="social-img-container"><img v-lazyload :src="'/assets/img/logo-pintrest.png'"></span>
            <span>FOLLOW US ON PINTEREST</span>
        </a>
    </div>
</template>

<script setup lang="ts">
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'

    const trackOutboundLink = (url: string): void => {
        ga.event('click', { 'event_category': 'outbound', 'event_label': url, 'transport_type': 'beacon' })
        clicky.log(url, 'outbound')
    }

    const joinWhatsapp = (url: string): void => {
        ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' })
        clicky.goal("JoinWhatsAppSocialLinks")
    }
</script>